import { pagerDutyApiRef, PagerDutyClient } from './api/client.esm.js';
import { createRouteRef, createPlugin, createApiFactory, discoveryApiRef, configApiRef, fetchApiRef, createComponentExtension } from '@backstage/core-plugin-api';
import { createCardExtension } from '@backstage/plugin-home-react';

createRouteRef({
  id: "pagerduty"
});
const pagerDutyPlugin = createPlugin({
  id: "pagerduty",
  apis: [
    createApiFactory({
      api: pagerDutyApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        configApi: configApiRef,
        fetchApi: fetchApiRef
      },
      factory: ({ configApi, discoveryApi, fetchApi }) => PagerDutyClient.fromConfig(configApi, { discoveryApi, fetchApi })
    })
  ]
});
const EntityPagerDutyCard = pagerDutyPlugin.provide(
  createComponentExtension({
    name: "EntityPagerDutyCard",
    component: {
      lazy: () => import('./components/EntityPagerDutyCard/index.esm.js').then(
        (m) => m.EntityPagerDutyCard
      )
    }
  })
);
const EntityPagerDutySmallCard = pagerDutyPlugin.provide(
  createComponentExtension({
    name: "EntityPagerDutySmallCard",
    component: {
      lazy: () => import('./components/EntityPagerDutySmallCard/index.esm.js').then(
        (m) => m.EntityPagerDutySmallCard
      )
    }
  })
);
const HomePagePagerDutyCard = pagerDutyPlugin.provide(
  createCardExtension({
    name: "HomePagePagerDutyCard",
    title: "PagerDuty Homepage Card",
    components: () => import('./components/HomePagePagerDutyCard/index.esm.js'),
    settings: {
      schema: {
        title: "PagerDuty",
        type: "object",
        properties: {
          integrationKey: {
            title: "PagerDuty integration key",
            type: "string"
          },
          serviceId: {
            title: "PagerDuty service id",
            type: "string"
          },
          name: {
            title: "PagerDuty service name",
            type: "string"
          }
        }
      }
    }
  })
);

export { EntityPagerDutyCard, EntityPagerDutySmallCard, HomePagePagerDutyCard, pagerDutyPlugin };
//# sourceMappingURL=plugin.esm.js.map
